<template>
  <!-- 车辆押金流水 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">押金流水</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label>
          <el-select v-model="filterForm.coalMineNo" clearable filterable placeholder="请选择煤矿">
            <el-option
              v-for="item in allCoalmineList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.receiverPhone" placeholder="驻矿id" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.carLicensePlateNo" placeholder="车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.userPhone" placeholder="司机手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.transStatus" clearable placeholder="请选择变化类型">
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.transTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-credit-card-alt"
            label="退款"
            perms="-1"
            type="primary"
            @click="handleRefund"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-sign-out"
            label="导出"
            v-loading.fullscreen.lock="fullscreenLoading"
            perms="30920"
            type="primary"
            @click="handleExport"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      v-loading="loading"
      :data="financeList"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="flowNo"
    >
      <el-table-column
        type="index"
        width="50"
        align="center"
        fixed
        label="序号">
      </el-table-column>
      <el-table-column
        prop="coalMineName" 
        align="center" 
        label="矿名">
      </el-table-column>
      <!-- <el-table-column
        prop="receiverPhone" 
        align="center" 
        label="收款手机号">
      </el-table-column> -->
      <el-table-column
        prop="carLicensePlateNo"
        align="center"
        label="车牌号">
      </el-table-column>
      <el-table-column
        prop="userPhone"
        align="center"
        label="司机手机号">
      </el-table-column>
      <el-table-column
        prop="transAmount"
        align="center"
        label="金额（元）">
          <template slot-scope="scope">
            {{scope.row.transAmount * 0.01}}
          </template>
      </el-table-column>
      <el-table-column
        prop="receiverPhone"
        align="center"
        label="驻矿id">
      </el-table-column>
      <el-table-column
        align="center"
        label="种类">
         车辆押金
      </el-table-column>
      <el-table-column
        prop="transType"
        align="center"
        label="交易类型">
          <template slot-scope="scope">
            {{scope.row.transType == 0 ? '支付' : '退款'}}
          </template>
      </el-table-column>
      <el-table-column
        prop="transStatusDesc"
        align="center"
        label="状态">
      </el-table-column>
      <el-table-column
        width="150"
        prop="transEndTime"
        align="center"
        label="时间">
      </el-table-column>
      <el-table-column
        width="150"
        prop="remark"
        align="center"
        label="备注">
      </el-table-column>
      <el-table-column
        prop="createUser" 
        align="center" 
        label="操作人">
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;"
      ></el-pagination>
    </div>
    <!-- 退款弹窗 -->
    <el-dialog
      title="退款"
      :visible.sync="refundDialogVisible"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="600px"
    >
      <div>
        <el-form
          :model="refundForm"
          :rules="dataRules"
          ref="refundForm"
          label-width="90px"
          :size="size"
          class="dataForm"
        >
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item label="车牌号">
                <el-input v-model="carNumber" placeholder="请输入车牌号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <kt-button
                icon="fa fa-search"
                label="查找"
                perms="-1"
                type="primary"
                style="margin-top: 3px"
                @click="handleSearchRentInfo"
              />
            </el-col>
          </el-row>
          <el-row v-if="showdetail">
             <el-row>
              <el-col :span="23">
                <el-form-item label="司机手机号">
                  <span>{{refundForm.userPhone}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="23">
                <el-form-item label="交易金额">
                  <span>{{refundForm.transAmount / 100}}元</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="23">
                <el-form-item label="种类">
                  <span>车辆押金</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="退款原因" prop="remark">
                <el-input
                  v-model="refundForm.remark"
                  type="textarea"
                  placeholder="请输入退款原因，50个字以内"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

let that = null;
export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      fullscreenLoading: false,
      searchLoading: false,
      financeList: [],
      allCoalmineList: [],
      parkList: [],
      statusList: [
        {name: '交易中', code : '0'},
        {name: '交易成功', code : '1'},
        {name: '交易失败', code : '2'},
      ],
      filterForm: {},
      refundDialogVisible: false,
      carNumber: '',
      showdetail: false,
      refundForm: {},
      dataRules: {
        remark: [{ required: true, message: "请输入退款原因", trigger: "blur" }]
      }
    };
  },
  created() {
    that = this;
  },
  mounted() {
    this.getPurchaseAccountList();
    this.getAllCoalmineList();
  },
  methods: {
    // 获取车辆流水列表
    async getPurchaseAccountList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          if (key === "transTime") {
            params["payListQueryDto.transStartTime"] = `${val[0]} 00:00:00`;
            params["payListQueryDto.transEndTime"] = `${val[1]} 23:59:59`;
          } else {
            params["payListQueryDto." + key] = val;
          }
        }
      }
      params['payListQueryDto.payScene'] = 1
      let res = await this.$api.finance.getCarRentAccountList(params);
      const data = res.data;
      this.totalSize = data.totalSize || 0;
      if (data && data.dtoList && data.dtoList.length > 0) {
        this.financeList = data.dtoList;
      } else {
        this.financeList = [];
      } 
      this.loading = false;
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getPurchaseAccountList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getPurchaseAccountList();
    },
    handleReset() {
      this.filterForm = {};
      this.handleSearch();
    },
    // 获取所有煤矿
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then(res => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },
    // 显示退款
    handleRefund() {
      this.refundDialogVisible = true;
    },
    dialogCloseCallback() {
      if (this.$refs.refundForm) {
        this.showdetail = false
        this.refundForm = {};
        this.carNumber = "";
        this.$refs["refundForm"].resetFields();
      }
    },
    // 根据车牌号查询详情
    async handleSearchRentInfo(){
      if (!this.carNumber) {
        this.$message({
          message: "请输入车牌号",
          type: "warning"
        });
        return;
      }
      const params = {
        pageNo: 1,
        pageSize: 1,
      };
      params['payListQueryDto.carLicensePlateNo'] = this.carNumber
      params['payListQueryDto.payScene'] = 1
      let res = await this.$api.finance.getCarRentAccountList(params);
      if(res.data.totalSize == 0){
        this.$message({
          message: "暂无该车牌号付款记录",
          type: "warning"
        });
        return
      }
      this.refundForm = res.data.dtoList[0]
      if(this.refundForm.remark){
        this.refundForm.remark = ''
      }
      this.showdetail = true
    },
    // 提交退款
    submitForm(){
      if (!this.refundForm.orderId) {
        if(this.carNumber){
          this.$message({
            message: "请输入正确的车牌号",
            type: "warning"
          });
          return
        }
        this.$message({
          message: "请先查找车辆对应的流水",
          type: "warning"
        });
        return false;
      }

      this.$refs["refundForm"].validate(valid => {
        if (valid) {
          const params = {
            orderId: this.refundForm.orderId,
            transAmount: this.refundForm.transAmount,
            originalTransNo: this.refundForm.transNo,
            remark: this.refundForm.remark
          };
          this.$api.finance.refundCar(params).then(res => {
            this.$message({ message: "操作成功", type: "success" });
            this.dialogCloseCallback();
            this.showdetail = false
            this.refundDialogVisible = false;
            this.getPurchaseAccountList();
          });
        }
      });
    },
    // 导出
    handleExport() {
      this.fullscreenLoading = true;
      let params = {
        pageNo: 1,
        pageSize: 10000
      };
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          if (key === "transTime") {
            params["payListQueryDto.transStartTime"] = `${val[0]} 00:00:00`;
            params["payListQueryDto.transEndTime"] = `${val[1]} 23:59:59`;
          } else {
            params["payListQueryDto." + key] = val;
          }
        }
      }
      params['payListQueryDto.payScene'] = 1
      this.$api.finance.getCarRentAccountList(params).then(res => {
        const data = res.data;
        if (data && data.dtoList && data.dtoList.length > 0) {
          const list = this.exportFormat(data.dtoList);
          list.map(item => {
            item.transAmount = item.transAmount / 100
            item.transTypeDesc = item.transType == 0 ? '支付' : '退款'
            item.type = '车辆押金'
          })
          this.exportExcel(list);
          this.fullscreenLoading = false;
        } else {
          this.$message({ message: "暂无数据" });
          this.fullscreenLoading = false;
        }
      });
    },
    exportExcel(list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../utils/Export2Excel");
        const tHeader = [
          "序号",
          "矿名",
          // "收款手机号",
          "车牌号",
          "司机手机号",
          "金额（元）",
          "驻矿id",
          "种类",
          "交易类型",
          "状态",
          "时间",
          "备注",
          "操作人"
        ]; // 设置Excel的表格第一行的标题
        const filterVal = [
          "index",
          "coalMineName",
          // "receiverPhone",
          "carLicensePlateNo",
          "userPhone",
          "transAmount",
          "receiverPhone",
          "type",
          "transTypeDesc",
          "transStatusDesc",
          "transEndTime",
          "remark",
          "createUser"
        ];
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "押金流水"); //导出Excel 文件名
      });
    },
    // 导出时类型转化
    exportFormat(res) {
      const list = res;
      list.forEach((item, index) => {
        item["index"] = index + 1;
        item["remark"] = item["remark"] || "无";
      });
      return list;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
</style>
